import { Subscription } from 'rxjs';

/* eslint-disable @typescript-eslint/no-empty-function */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  UntypedFormArray,
  UntypedFormControl,
} from '@angular/forms';
import { RouterService } from '@ellf/app-routing';

@Component({
    selector: 'ellf-checkboxlist',
    templateUrl: './checkbox-list.component.html',
    styleUrls: ['./checkbox-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckBoxListComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => CheckBoxListComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class CheckBoxListComponent
  implements OnInit, ControlValueAccessor, OnDestroy
{
  @Input()
  items: { id: string; description: string }[] = [];

  @Output()
  changed = new EventEmitter();

  isDisabled = false;

  @Input()
  hasError = false;

  value: string[] = [];

  form = new UntypedFormArray([]);

  subscription?: Subscription;

  propagateChange = (value: string[]) => {};
  validateFn: any = () => {};
  onTouched = () => {};

  constructor(
    private cd: ChangeDetectorRef,
    private routerService: RouterService
  ) {}

  getControl(i: number) {
    return this.form.at(i) as UntypedFormControl;
  }

  writeValue(obj: string[]): void {
    this.items.forEach((item, index) => {
      const selected = obj.find((id) => id === item.id) != null;
      this.form.at(index).setValue(selected, { emitEvent: false });
    });

    this.cd.markForCheck();
  }

  registerOnChange(fn: (value: any) => void) {
    this.propagateChange = fn;
  }

  setDisabledState(isDisabled: any): void {
    this.isDisabled = isDisabled;
    if (isDisabled) this.form.disable();
    else this.form.enable();
    this.cd.markForCheck();
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  validate(control: UntypedFormControl) {
    const res = this.validateFn(control);
    if (res) this.hasError = true;
    return res;
  }

  ngOnInit(): void {
    this.items.forEach((item) => {
      this.form.push(new UntypedFormControl(false));
    });

    this.subscription = this.form.valueChanges.subscribe((formValue) => {
      const value = this.items
        .filter((item, index) => this.form.at(index).value)
        .map((item) => item.id);

      this.onModelChange(value);
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  onModelChange($event: string[]) {
    this.changed.emit($event);
    this.propagateChange($event);
    this.onTouched();
  }
}
